import * as THREE from 'three';
import { sceneHelper } from '../helper/scene-helper';
import { resolveCmsDevProxyUrl } from '../cms-dev-proxy-url';

export async function runSetSkySphereImplementation(data: {
  background?: { url?: string };
  enabled?: boolean;
}) {
  if (!sceneHelper) return;

  const enabled = data.enabled ?? true;
  if (!enabled) {
    sceneHelper.removeSceneBackground();
    return;
  }

  const rawUrl = data.background?.url;
  if (!rawUrl) {
    console.error('Set Sky Sphere: missing background asset url');
    return;
  }

  const url = resolveCmsDevProxyUrl(rawUrl) ?? rawUrl;

  if (sceneHelper.skySphere) {
    sceneHelper.skySphere.visible = true;
  }

  await sceneHelper.setSceneBackground(
    url,
    THREE.EquirectangularReflectionMapping,
    THREE.SRGBColorSpace
  );
}
